export const HELP_URL = 'https://help.paperlessparts.com/category/608-p3l';
export const FORMULA_COMPILE_SUCCESS_MSG = 'Ready to save';

export const P3L_CODE_MIRROR_OPTIONS = {
  indentUnit: 4,
  mode: 'python',
  lineNumbers: true,
  smartIndent: true,
  tabSize: 4,
};
